export class Unpaid {
    costCenterId: number;
    costCenterName: string;
    unpaidCount: number;
    unpaidAmount: number;
}

export class UnpaidDetails {
    costCenterId: number;
    costCenterName: string;
    unpaidTicketsCount: number;
    unpaidTicketsAmount: number;
    unpaidCreditTicketsCount: number;
    unpaidCreditTicketsAmount: number;
}


// WEBPACK FOOTER //
// C:/TeamCity/BuildAgent3/work/c38c6eefb6a115e8/HSG.Accounting/HSG.Accounting.MonitoringMobileApp/src/app/unpaid/unpaid.model.ts